import React, { useState, useCallback, ReactElement } from 'react';
import * as css from './OdometerInformation.module.scss';
import 'src/css/themes.scss';
import { IconSeeMore } from 'src/content/icons';
import { ConnectedVehicleRec } from 'src/models';
import { Dialog, ScrollBar } from '@framework-controls/core';
import { strings } from 'src/localization';

export interface IProps {
    connectedVehicle: ConnectedVehicleRec;
}

const OdometerInformation = (props: IProps) => {
    const [infoOpen, setInfoOpen] = useState(false);
    const toggleInfo = useCallback(() => {
        setInfoOpen(!infoOpen);
    }, [infoOpen]);

    let odometerTstamp: ReactElement | null = null;
    if (props.connectedVehicle.mileTstamp) {
        let statusLit = strings.DataAsOf;
        if (props.connectedVehicle.mileStatus) {
            statusLit = props.connectedVehicle.mileStatus + ' ' + strings.AsOf;
        }
        odometerTstamp = <p className={css.statusLit}>{statusLit + ' ' + props.connectedVehicle.mileTstamp}</p>;
    }

    let odometer: ReactElement | null = null;
    if (props.connectedVehicle.mileage) {
        odometer = <span className={css.infoBlock}>
            <div className={css.infoLit}>
                {strings.Odometer}
            </div>
            <div className={css.infoData}>
                {props.connectedVehicle.mileage}
            </div>
            {odometerTstamp}
        </span>;
    }

    let avgDistance: ReactElement | null = null;
    if (props.connectedVehicle.mileAvgDistance) {
        avgDistance = <span className={css.infoBlock}>
            <div className={css.infoLit}>
                {strings.AvgDistancePerWeek}
            </div>
            <div className={css.infoData}>
                {props.connectedVehicle.mileAvgDistance}
            </div>
        </span>;
    }

    return (
        <div className={css.block}>
            <div className={css.icon}>
                <IconSeeMore onClick={() => toggleInfo()} />
            </div>
            <Dialog
                cssClasses={{
                    content: css.content,
                    paper: css.paper,
                    header: css.LightBoxHeader,
                }}
                isOpen={infoOpen}
                anchorOrigin={{
                    vertical: 'top',
                }}
                header={strings.OdometerInformation.toUpperCase()}
                hideSave={true}
                hideCancel={true}
                disableUpperCase={true}
                onCancel={() => toggleInfo()}
                onBackDropClick={() => toggleInfo()}
                width={'full'}
            >
                <ScrollBar scrollVertical>
                    <div className={css.infoRow}>
                        {odometer}
                        {avgDistance}
                    </div>
                </ScrollBar>
            </Dialog>
        </div>
    );
};

export default OdometerInformation;